export default class UserProductEndUseService {
  constructor($http) {
    this.$http = $http;
  }

  get(user_id) {
    return this.$http.get(
      '/admin/marketplace/users/get_product_end_uses',
      {params: {user_id: user_id}}
    );
  }

  update(user_id, product_end_uses) {
    return this.$http.post(
      '/admin/marketplace/users/update_product_end_uses',
      {user_id: user_id, product_end_uses: product_end_uses, authenticity_token: window.token}
    );
  }
}

UserProductEndUseService.$inject = ['$http'];



// WEBPACK FOOTER //
// ./front/js/admin/services/user-product-end-use.service.js